// extracted by mini-css-extract-plugin
export default {"security":"securityBlurb_security__QYwe5"};